module.exports = __webpack_public_path__ + "static/media/widows.16717756.png";